import UIFlex from 'UIComponents/layout/UIFlex';
import { useSearchParams } from '../../../utils/searchParams';
import styled, { useMediaQuery } from 'academy-common-lib/utils/Styling';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITag from 'UIComponents/tag/UITag';
import { PublicCatalogFilters } from '../publicCatalogConstants';
import UIButton from 'UIComponents/button/UIButton';
import LanguageNames from 'ui-addon-i18n/constants/LanguageNames';
import UIBox from 'UIComponents/layout/UIBox';
import { useClearAllFilters, useRemoveFilter } from '../publicCatalogFiltersHooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ClearAllButton = styled(UIButton).withConfig({
  displayName: "PublicCatalogAppliedFilters__ClearAllButton",
  componentId: "sc-1ikibz9-0"
})(["width:max-content !important;&:only-child{display:none;}"]);
const AppliedFilters = () => {
  const {
    isMobile
  } = useMediaQuery();
  const [searchParams] = useSearchParams();
  const clearAllFilters = useClearAllFilters();
  const removeFilter = useRemoveFilter();
  return /*#__PURE__*/_jsx("div", {
    style: {
      overflowX: isMobile ? 'scroll' : 'auto'
    },
    children: /*#__PURE__*/_jsxs(UIFlex, {
      className: isMobile ? 'p-x-5 p-y-2 ' : '',
      gap: 12,
      style: {
        width: 'fit-content',
        maxWidth: 'none'
      },
      wrap: isMobile ? 'nowrap' : 'wrap',
      children: [Object.entries(PublicCatalogFilters).map(([filterName, filterOptions]) => {
        const filterValuesApplied = searchParams[filterName] || [];
        if (filterValuesApplied.length === 0) {
          return null;
        }
        // language may not have multiple values so only take the last one
        const validFilterValues = filterName === 'language' ? filterValuesApplied.slice(-1) : filterValuesApplied;
        return validFilterValues.map(optionValue => {
          const selectedOptions = [...filterOptions];
          const selectedOption = selectedOptions.find(option => option === optionValue);
          if (!selectedOption) {
            return null;
          }
          return /*#__PURE__*/_jsx(UIBox, {
            shrink: 0,
            children: /*#__PURE__*/_jsx(UITag, {
              className: "m-left-0",
              closeable: true,
              "data-test-id": "applied-filter-tag",
              onCloseClick: () => {
                removeFilter(filterName, selectedOption);
              },
              children: filterName === 'language' ? LanguageNames[selectedOption] : /*#__PURE__*/_jsx(FormattedMessage, {
                message: `academyPublic.catalogPage.filters.${filterName}.options.${selectedOption}`
              })
            })
          }, selectedOption);
        });
      }), /*#__PURE__*/_jsx(ClearAllButton, {
        className: "m-left-3",
        onClick: clearAllFilters,
        use: "link",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyPublic.catalogPage.filters.clearFilters"
        })
      })]
    })
  });
};
export default AppliedFilters;